export default "/vendor/glyphicons-halflings-regular.864c2bdfdea09ee848334af61b5e14d0.svg";